<template>

    <div class="px-6 py-4 bg-minplan-beige -mb-4">
        <page-title :title="$t('agencies.newAgency')"></page-title>
    </div>

    <jet-form-section @submitted="createAgency()">

        <template #form>

            <!-- Card Agency Information -->
            <form-card :title="$t('agencies.agency')" :description="$t('agencies.agencyDescription')">

                <div class="col-span-6">
                    <label for="name" class="block text-sm font-medium text-gray-700">{{ $t("agencies.name") }} <RequiredMark /></label>
                    <input type="text" name="name" id="name" v-model="form.name"
                            class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300" autofocus />
                    <jet-input-error :message="form.errors.name" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label for="ownerFirstname" class="block text-sm font-medium text-gray-700">{{ $t("agencies.ownerFirstname") }} <RequiredMark /></label>
                    <input type="text" name="ownerFirstname" id="ownerFirstname" v-model="form.ownerFirstname"
                            class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300" />
                    <jet-input-error :message="form.errors.ownerFirstname" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label for="ownerLastname" class="block text-sm font-medium text-gray-700">{{ $t("agencies.ownerLastname") }} <RequiredMark /></label>
                    <input type="text" name="ownerLastname" id="ownerLastname" v-model="form.ownerLastname"
                            class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300" />
                    <jet-input-error :message="form.errors.ownerLastname" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label for="ownerEmail" class="block text-sm font-medium text-gray-700">{{ $t("agencies.ownerEmail") }} <RequiredMark /></label>
                    <input type="text" name="ownerEmail" id="ownerEmail" v-model="form.ownerEmail"
                            class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300" />
                    <jet-input-error :message="form.errors.ownerEmail" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label for="ownerMobile" class="block text-sm font-medium text-gray-700">{{ $t("agencies.ownerMobile") }} <RequiredMark /></label>
                    <input type="text" name="ownerMobile" id="ownerMobile" v-model="form.ownerMobile"
                            class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300" />
                    <jet-input-error :message="form.errors.ownerMobile" class="mt-2" />
                </div>

            </form-card>

        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">

                <button @click="cancel" type="button" class="inline-block uppercase font-semibold text-xs tracking-widest">
                    {{ $t("actions.cancel") }}
                </button>

                <primary-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="ml-3 ">
                    {{ $t("actions.save") }}
                </primary-button>

            </div>
        </template>

    </jet-form-section>

</template>


<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm } from "@inertiajs/inertia-vue3";
import { Switch, SwitchGroup, SwitchLabel } from "@headlessui/vue";
import FormCard from "@/Shared/Components/FormCard";
import RequiredMark from "@/Shared/Components/RequiredMark";

export default defineComponent({
    props: [],
    inheritAttrs: false,
    layout: MainLayout,
    emits: ["closeModal"],
    components: {
        PageTitle,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        SwitchGroup,
        SwitchLabel,
        Switch,
        FormCard,
        RequiredMark
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        createAgency() {
            this.form.post(this.route("admin.agencies.store"), {
                preserveScroll: true,
                onSuccess: () => this.$notify({
                    group: "success",
                    title: 'actions.success',
                    text: 'agencies.created'
                })
            });
        }
    },
    setup() {

        const form = useForm({
            name: null,
            ownerFirstname: null,
            ownerLastname: null,
            ownerEmail: null,
            ownerMobile: null,
        });

        return { form };
    }
});
</script>

<style scoped></style>
